<template>
  <!-- 당근 구매 패널 (GatherPage 구매하기 탭 + 당근 다이얼로그 공용) -->
  <div>
    <div class="shop-grid">
      <v-card v-for="pkg in packages" :key="pkg.carrots" class="pkg-card" outlined hover>
        <div class="pkg-card__emoji">🥕</div>
        <div class="pkg-card__amount">{{ pkg.carrots.toLocaleString() }}</div>
        <div v-if="pkg.bonus" class="pkg-card__bonus">+{{ pkg.bonus.toLocaleString() }} 보너스</div>
        <v-btn class="pkg-card__buy" rounded depressed disabled>{{ priceLabel(pkg) }} · 준비중</v-btn>
      </v-card>
    </div>
    <p class="text-caption grey--text mt-3 mb-0">※ 결제 연동은 준비 중입니다.</p>
  </div>
</template>

<script>
import { CARROT_PACKAGES, currencyForLocale, formatPrice } from "@/constants/currencyPackages";

export default {
  name: "CarrotShopPanel",
  data: () => ({ packages: CARROT_PACKAGES }),
  computed: {
    currency() {
      return currencyForLocale(this.$i18n.locale);
    },
  },
  methods: {
    priceLabel(pkg) {
      return formatPrice(pkg.price[this.currency], this.currency, this.$i18n.locale);
    },
  },
};
</script>

<style scoped>
.shop-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 14px;
  padding-top: 4px;
}
.pkg-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 22px 16px 18px;
  border-radius: 16px;
}
.pkg-card__emoji {
  font-size: 40px;
}
.pkg-card__amount {
  font-size: 22px;
  font-weight: 800;
  color: #6a4a14;
}
.pkg-card__bonus {
  font-size: 12px;
  font-weight: 700;
  color: #e0892b;
}
.pkg-card__buy {
  margin-top: 10px;
  width: 100%;
  font-weight: 700 !important;
}
</style>
